import { useAlertUiTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Paper, Stack, Tooltip } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import React from 'react';
import { channelIcon, channelText } from './types';
const AlertCard = (props) => {
    var _a;
    const { item } = props;
    const { t } = useAlertUiTranslation();
    return (React.createElement(Box, { sx: { p: 1.5 } },
        React.createElement(Chip, { sx: { color: themeColors.icon.subtle, height: 20, fontSize: 12, fontWeight: 400 }, label: item.messageType, size: 'small', "data-test": 'message-type-chip' }),
        React.createElement(Typography, { component: 'div', variant: 'h6', pt: 0.5, noWrap: true, "data-test": 'message-title' }, item.title),
        React.createElement(Stack, { direction: 'row', spacing: -0.5, pt: 1 }, (_a = item.channels) === null || _a === void 0 ? void 0 : _a.map((ch) => (React.createElement(Tooltip, { key: ch, title: channelText(ch, t) },
            React.createElement(Paper, { sx: {
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    color: themeColors.icon.subtle,
                    mr: 1,
                    boxShadow: 'none',
                    '&:not(style)+:not(style)': {
                        ml: 0,
                        mr: 1,
                    },
                }, key: ch, role: 'img', "aria-label": channelText(ch, t) },
                React.createElement(SvgIcon, { sx: { fontSize: 20 }, "data-test": `${ch}-channel-icon` }, channelIcon[ch]))))))));
};
export default AlertCard;
